import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Dialog, DialogDescription, DialogOverlay, DialogPortal } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useMountEffect } from '@react-hookz/web';
import { useCallback, useRef } from 'react';
import { Backdrop, CloseButton, Content, Title } from '../../primitives/ContentLayer/components/index.js';
export const ContentLayer = ({
  open = false,
  onClose,
  closeButtonLabel,
  children,
  title,
  visuallyHideTitle,
  description,
  fullscreen,
  className
}) => {
  const portalRoot = useRef(null);
  useMountEffect(() => {
    portalRoot.current = document.getElementById('portal-root');
  });
  const handleOpenChange = useCallback(open => {
    if (!open && onClose) {
      onClose();
    }
  }, [onClose]);
  const shouldRenderDescription = Boolean(description);
  const describedBy = {};
  if (!shouldRenderDescription) {
    describedBy['aria-describedby'] = undefined;
  }
  return _jsx(Dialog, {
    open: open,
    onOpenChange: handleOpenChange,
    modal: true,
    children: _jsx(DialogPortal, {
      container: portalRoot.current,
      children: _jsxs(DialogOverlay, {
        children: [_jsx(Backdrop, {}), _jsxs(Content, {
          ...describedBy,
          fullscreen: fullscreen,
          className: className,
          children: [_jsx(Title, {
            visuallyHidden: visuallyHideTitle,
            children: visuallyHideTitle ? _jsx(VisuallyHidden, {
              children: title
            }) : title
          }), _jsx(VisuallyHidden, {
            asChild: true,
            children: _jsx(DialogDescription, {
              children: description
            })
          }), _jsx(CloseButton, {
            label: closeButtonLabel
          }), children]
        })]
      })
    })
  });
};